import Vue from 'vue'
import axios from 'axios'

const API_URL = '/api/editor/'
function parseJwt(jwt) {
  if (!jwt) {
    return null
  }
  const encodedPayload = jwt.split('.')[1]
  let base64 = encodedPayload?.replace(/-/g, '+')?.replace(/_/g, '/')
  while (base64?.length % 4) {
    base64 += '='
  }
  const decodedPayload = atob(base64)
  return JSON.parse(decodedPayload)
}


let instance

export const Api = () => {
    if (instance) return instance

    instance = new Vue({
        data() {
            return {
                rawToken: localStorage.getItem('token'),
                handle: null,
            }
        },
        created() {
            // Create a new instance of the SDK client using members of the given options object
            this.clientFactory()
        },
        computed: {
            token: {
                get() {
                    return this.rawToken;
                },
                set(token) {
                    if (token === null) {
                        localStorage.removeItem('token');
                    } else {
                        localStorage.setItem('token', token);
                    }
                    this.rawToken = token;
                }
            },
            payload() {
                return parseJwt(this.token)
            },
            isAuthenticated() {
                return this.token !== null
            },
            user() {
                return this.payload ? this.payload.user_info : null
            }
        },
        methods: {
            clientFactory() {
                const fragment = window.location.hash.substring(2)
                const params = new URLSearchParams(fragment)
                if (params.has('token')) {
                  this.rawToken = params.get('token')
                  if (this.rawToken !== null) {
                    localStorage.setItem('token', this.rawToken)
                  } else {
                    localStorage.removeItem('token')
                  }
                  params.delete('token')
                  window.location.hash = params.toString()
                } else if (params.has('error')) {
                    alert(`error: ${params.get('error')} \ndescription: ${params.get('error_description')}`)
                }

                const rawPayload = parseJwt(this.rawToken)
                const now = Math.floor(Date.now() / 1000)
                if (rawPayload !== null && rawPayload.exp !== null && rawPayload.exp < now) {
                  localStorage.removeItem('token')
                  this.rawToken = null
                }

                if (!this.isAuthenticated) {
                 this.login()
                }
            },
            login() {
                window.location.href = '/api/authenticate'
            },
            logout() {
                this.token = null
                window.location.href = '/api/logout'
            },
            async request(method, url, data) {
                const token = await this.token
                const headers = token ? {Authorization: `Bearer ${token}`} : {}
                url = API_URL + url
                try {
                    return await axios.request({ method, url, data, headers })
                } catch(error) {
                    if (error.response.status === 403) {
                        await this.login()
                    }
                    throw error
                }
            },
            async get(url) {
                return await this.request('GET', url)
            },
            async post(url, data) {
                return await this.request('POST', url, data)
            },
            async put(url, data) {
                return await this.request('PUT', url, data)
            },
            async delete(url) {
                return await this.request('DELETE', url)
            }
        }
    })

    return instance
}

export const ApiPlugin = {
    install(Vue) {
        Vue.prototype.$api = Api()
    }
}
